import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Fieldset, Legend,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import CustomSelect from "../../../../helpers/ui/CustomSelect"
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            is_tanggal: false,
            optionTahun: [
                { label: "2022", value: "2022" },
                { label: "2023", value: "2023" },
                { label: "2024", value: "2024" },
                { label: "2025", value: "2025" },
                { label: "2026", value: "2026" },
                { label: "2027", value: "2027" },
                { label: "2028", value: "2028" },
                { label: "2029", value: "2029" },
                { label: "2030", value: "2030" },
            ],
            optionBulan: [
                { label: "Jan", value: "1" },
                { label: "Feb", value: "2" },
                { label: "Mar", value: "3" },
                { label: "Apr", value: "4" },
                { label: "Mei", value: "5" },
                { label: "Jun", value: "6" },
                { label: "Jul", value: "7" },
                { label: "Ags", value: "8" },
                { label: "Sep", value: "9" },
                { label: "Okt", value: "10" },
                { label: "Nov", value: "11" },
                { label: "Des", value: "12" },
            ],
            optionJenis: [
                { label: "End Of Month", value: "1" },
                { label: "Tanggal", value: "2" },
            ],
            optionKategori: [
                { label: "Tunjangan Kinerja", value: "1" },
                { label: "Honorarium", value: "2" },
                { label: "Uang Makan", value: "3" },
            ],
            optionTanggal: [
                { label: "1", value: "1" },
                { label: "2", value: "2" },
                { label: "3", value: "3" },
                { label: "4", value: "4" },
                { label: "5", value: "5" },
                { label: "6", value: "6" },
                { label: "7", value: "7" },
                { label: "8", value: "8" },
                { label: "9", value: "9" },
                { label: "10", value: "10" },
                { label: "11", value: "11" },
                { label: "12", value: "12" },
                { label: "13", value: "13" },
                { label: "14", value: "14" },
                { label: "15", value: "15" },
                { label: "16", value: "16" },
                { label: "17", value: "17" },
                { label: "18", value: "18" },
                { label: "19", value: "19" },
                { label: "20", value: "20" },
                { label: "21", value: "21" },
                { label: "22", value: "22" },
                { label: "23", value: "23" },
                { label: "24", value: "24" },
                { label: "25", value: "25" },
                { label: "26", value: "26" },
                { label: "27", value: "27" },
                { label: "28", value: "28" },
                // { label: "29", value: "29" },
                // { label: "30", value: "30" },
                // { label: "31", value: "31" }
            ],
            employeeOptions: [],
            selectedEmployee: null,
            isLoadingOptEmployee: true,
            polaKerjaOptions: [],
            selectedPolaKerja: null,
            isLoadingOptPolaKerja: true
        }
    }

    reformatOptionsEmployee = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data['employee_nip'] + ' - ' + data[label];
            newObj["value"] = data[value];
            newObj["model"] = data;

            return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];
            newObj["model"] = data;

            return newObj;
        });
    };

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }
    handleTypeSelected = (periode_verifikasi_type) => {
        let selected = periode_verifikasi_type.value;
        if (selected == 2) {
            this.setState({
                is_tanggal: true
            })
        } else {
            this.setState({
                is_tanggal: false
            })
        }
        console.log(this.state.is_tanggal)
    }


    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            employeeOptions: this.reformatOptionsEmployee(
                                response.result,
                                'employee_full_name',
                                'employee_uuid',
                            ),
                            isLoadingOptEmployee: false
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.createBloc.polaKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            polaKerjaOptions: this.reformatOptions(
                                response.result,
                                'working_pattern_name',
                                'working_pattern_uuid',
                            ),
                            isLoadingOptPolaKerja: false
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })


        // this.createBloc.fetchEmployee()
        // this.createBloc.fetchPolaKerja()
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        // this.createBloc.employeeChannel?.unsubscribe()
        // this.createBloc.polaKerjaChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody style={{ minHeight: "500px" }}>
                                    <CardTitle>Tambah Periode Verifikasi</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Kategori
                                            </label>
                                            <Col md="3">
                                                <CustomSelect
                                                    name="periode_verifikasi_category"
                                                    errorMessage="Pilih Kategori"
                                                    options={this.state.optionKategori}
                                                    placeholder="Pilih Kategori"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis
                                            </label>
                                            <Col md="3">
                                                <CustomSelect
                                                    name="periode_verifikasi_type"
                                                    errorMessage="Pilih Jenis"
                                                    options={this.state.optionJenis}
                                                    onChange={this.handleTypeSelected}
                                                    placeholder="Pilih Jenis"
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Collapse isOpen={this.state.is_tanggal && true}>
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="no_sk"
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Tanggal Akhir Absen
                                                    </label>
                                                    <Col md="3">
                                                        <CustomSelect
                                                            name="periode_verifikasi_tanggal"
                                                            errorMessage="Pilih Tanggal"
                                                            options={this.state.optionTanggal}
                                                            placeholder="Pilih Tanggal"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        </Collapse>
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Berlaku Mulai (Bln - Tahun)<span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <Row>
                                                    <Col md="6">
                                                        <CustomSelect
                                                            name="periode_verifikasi_start_month"
                                                            errorMessage="Pilih Bulan"
                                                            options={this.state.optionBulan}
                                                            placeholder="Pilih Bulan"
                                                        />
                                                    </Col>
                                                    <Col md="6">
                                                        <CustomSelect
                                                            name="periode_verifikasi_start_year"
                                                            errorMessage="Pilih tahun"
                                                            options={this.state.optionTahun}
                                                            defaultValue={new Date().getFullYear()}
                                                            placeholder="Pilih tahun"
                                                        />
                                                    </Col>


                                                </Row>
                                            </Col>
                                        </Row>


                                        {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                    <AvCheckboxGroup name="checkboxExample" errorMessage="Agreement harus di centang">
                                                        <AvCheckbox label="Centang untuk mengaktifkan jam kerja ini dan menonaktifkan jam kerja yang sedang aktif" value="1" />
                                                    </AvCheckboxGroup>
                                                </div>
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/master/periode_verifikasi.html?' />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView